import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';
import { SiaLayoutService, SiaTranslatePipe, notify } from '@sia/shared';
import { AuthComponent } from '../../auth.component';
import { SiaAuthResult } from '../../interfaces/sia-auth-result';

@Component({
  selector: 'login-auto',
  templateUrl: './auth-login-auto.component.html',
  styleUrls: ['./auth-login-auto.component.scss'],
  standalone: true,
  imports: [SiaTranslatePipe, MatProgressSpinner, SiaTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLoginAutoComponent
  extends AuthComponent
  implements OnInit, OnDestroy
{
  siaLayoutService = inject(SiaLayoutService);
  aRouter = inject(ActivatedRoute);

  loginForm: FormGroup = new FormGroup({
    userIdentifier: new FormControl(''),
    password: new FormControl(''),
  });
  credentials = signal<any>({});
  menu = signal<string | undefined>(undefined);

  async ngOnInit() {
    super.ngOnInit();
    const isTokenExpired = await this.tokenStore.isCurrentTokenExpired();

    if (isTokenExpired) {
      await this.clearSession();
    }

    let s0 = this.aRouter.paramMap.subscribe((p) => {
      this.loginForm.setValue({
        userIdentifier: p.get('userId'),
        password: p.get('psw'),
      });
      this.menu.set(p.get('menu') ?? undefined);
      if (!this.loginForm || this.loginForm.invalid) {
        notify('Impossibile recuperare informazioni', 3000, 'error');
      } else {
        this.login();
      }
    });
    this.subs.push(s0);
  }

  async login() {
    if (!this.loginForm || this.loginForm.invalid) {
      return;
    }
    this.loginStarted.set(true);
    const creds = this.loginForm.value;
    this.credentials.set(creds);
    try {
      const result: SiaAuthResult = await this.authService.login(creds);
      if (result.success) {
        notify('Login effettuato. Attendere', 1000, 'success');
        await this.siaLayoutService.getAllLayouts();
      }
      await this.loginAfterTokenReceived(result, this.menu());
    } catch (e: any) {
    } finally {
      this.loginStarted.set(false);
    }
  }

  @HostListener('window:unload')
  override ngOnDestroy() {
    super.ngOnDestroy();
    this.credentials.set(null);
  }
}
